<template>
  <div class="flex my-auto">
    <image-kit
      v-for="index of [1, 2, 3, 4, 5]"
      :id="`star-${index}`"
      :path="`/icons/star-${index <= stars ? 'full' : 'empty'}.svg`"
      width="16"
      height="16"
      class="w-[16px] h-[16px] flex-shrink-0 object-cover rounded-4"
    />
  </div>
</template>
<script setup lang="ts">
import ImageKit from "@/components/imagekit/ImageKit.vue";

const props = defineProps({
  stars: {
    type: Number,
    required: true,
  },
});
</script>
